import { useState, useCallback, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import ApiManager from "../../api/ApiManager";
import Button from "../../components/Button/Button";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";
import Typography from "../../components/Typography/Typography";
import Input from "../../components/Input/Input";
import { ArrowLeft } from "lucide-react";
import { Toaster, toast } from "react-hot-toast";
import { useAuth } from "../../store/AuthContext/AuthContext";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";

const api = new ApiManager();

const LoginForm = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleChange = useCallback((e) => {
    setCredentials((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    api
      .post("/login", {
        email: credentials.email,
        password: credentials.password,
      })
      .then((res) => {
        login(res.data);
        navigate("/client/library");
      })
      .catch((error) => {
        console.error(error);
        toast(error.response.data.Message);
        setLoading(false);
      });
  };

  const isFormIncomplete = Object.values(credentials).some(
    (value) => value === ""
  );

  return (
    <>
      {loading && <LoadingOverlay />}
      
      <OnboardingLayout hasProgress={false}>
        <div className="pt-12 pb-14 md:mx-auto md:w-[40rem] w-auto px-4 flex flex-col gap-4 md:gap-9">
          <Toaster />
          <Button
            onClick={() => navigate(-1)}
            size="md"
            type="bw"
            icon={<ArrowLeft size="24" />}
          />
          <Typography
            family="serif"
            size="32"
            desktopSize="48"
            weight="sb"
            color="black"
          >
            Accedi al tuo account
          </Typography>
          {error && <p className="text-red-500">{error}</p>}
          <form className="flex flex-col gap-[36px]" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-4">
              <Input
                title="Email"
                name="email"
                value={credentials.email}
                onChange={handleChange}
              />
              <Input
                type="password"
                title="Password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                placeholder="7+ caratteri"
              />
            </div>
            <Button
              text="Accedi"
              width="full"
              size={window.innerWidth >= 768 ? "lg" : "md"}
              type="color"
              disabled={isFormIncomplete}
            />
          </form>
          <div className="flex w-full justify-center">
            <Typography desktopSize="16" size="12" weight="md" color="gray-600">Hai <Link className="underline" to="/recupero-password">dimenticato la password?</Link></Typography>
          </div>
        </div>
      </OnboardingLayout>
    </>
  );
};

export default LoginForm;